function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint semi: ["error", "never"]*/

/* eslint arrow-parens: ["error", "as-needed"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
import AsyncSelectMulti from '@engine/components/containers/async-select-multi';
import React from 'react';
import { connect } from 'react-redux';
import { requestConsumerAddress } from '@engine/actions/creators/pay-by-link-form';

var CustomerEmailContainer = /*#__PURE__*/function (_React$Component) {
  _inherits(CustomerEmailContainer, _React$Component);

  var _super = _createSuper(CustomerEmailContainer);

  function CustomerEmailContainer(props) {
    var _this;

    _classCallCheck(this, CustomerEmailContainer);

    _this = _super.call(this, props);
    _this.customerEmailInput = React.createRef();
    return _this;
  }

  _createClass(CustomerEmailContainer, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!this.props.with_address_retrieval) {
        return;
      }

      if (Object.keys(this.props.address).length !== 0 && this.props.address.id !== prevProps.address.id) {
        this.fillInAddress();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return React.createElement(React.Fragment, null, React.createElement(AsyncSelectMulti, {
        name: "pay_by_link_form[consumer_id]",
        url: "/pay_by_link/fetch_consumers_list/".concat(this.props.terminalId),
        id: this.props.id,
        isMulti: false,
        value: this.defaultConsumerValue,
        onChange: function onChange(value) {
          return _this2.onConsumerChange(value);
        }
      }), React.createElement("input", {
        name: "pay_by_link_form[customer_email]",
        defaultValue: this.defaultCustomerEmailValue,
        type: "hidden",
        ref: this.customerEmailInput
      }));
    }
  }, {
    key: "onConsumerChange",
    value: function onConsumerChange(option) {
      this.customerEmailInput.current.value = option.label;

      if (this.props.with_address_retrieval) {
        this.props.requestConsumerAddress("/pay_by_link/fetch_consumer_address/".concat(option.value, "/").concat(this.props.terminalId));
      }
    }
  }, {
    key: "fillInAddress",
    value: function fillInAddress() {
      var _this3 = this;

      var addressFields = ['first_name', 'last_name', 'address1', 'address2', 'zip_code', 'city', 'state'];
      addressFields.map(function (field) {
        var input = document.getElementById("pay_by_link_form_billing_address_".concat(field));
        input.value = _this3.props.address[field] || '';
        return null;
      });

      if (this.props.address.country) {
        this.fillInAddressCountry();
      }
    }
  }, {
    key: "fillInAddressCountry",
    value: function fillInAddressCountry() {
      var _this4 = this;

      var countrySelect = document.getElementById('pay_by_link_form_billing_address_country');
      var chosenUpdateEvent = new Event('chosen:updated');

      if (!countrySelect) {
        return;
      }

      _toConsumableArray(countrySelect.options).every(function (option) {
        if (option.value === _this4.props.address.country) {
          option.selected = true;
          return false;
        }

        return true;
      });

      countrySelect.dispatchEvent(chosenUpdateEvent);
    }
  }, {
    key: "defaultConsumerValue",
    get: function get() {
      if (this.props.consumer_id && this.props.customer_email) {
        return [{
          label: this.props.customer_email,
          value: this.props.consumer_id
        }];
      }

      return [];
    }
  }, {
    key: "defaultCustomerEmailValue",
    get: function get() {
      return this.customerEmailInput.current && this.customerEmailInput.current.value || this.props.customer_email;
    }
  }]);

  return CustomerEmailContainer;
}(React.Component);

CustomerEmailContainer.defaultProps = {
  with_address_retrieval: true
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    address: state.payByLinkForm.address
  };
};

export default connect(mapStateToProps, {
  requestConsumerAddress: requestConsumerAddress
})(CustomerEmailContainer);